import { formatDMY } from "@/lib/date";

const Cell = ({ label, children }) => (
  <div className="min-w-0">
    <p className="text-[10px] font-semibold uppercase tracking-wide text-[#94a3b8]">{label}</p>
    <p className="truncate text-sm font-medium text-[#0F172A]">{children}</p>
  </div>
);

export const MobileBookingCard = ({ b, statusCls, showEmail, fmtTime, fmtDuration, actions, testid }) => (
  <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm" data-testid={testid}>
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0">
        <p className="font-mono text-sm font-bold text-[#5C2D91]">{b.booking_ref}</p>
        <p className="mt-0.5 font-semibold text-[#0F172A]">{b.employee_name}</p>
        {showEmail && <p className="truncate text-xs text-[#64748B]">{b.company_email}</p>}
      </div>
      <span className={`shrink-0 rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ${statusCls}`}>{b.status}</span>
    </div>
    <div className="mt-3 grid grid-cols-2 gap-x-4 gap-y-2.5 rounded-lg bg-slate-50 p-3">
      <Cell label="Vehicle">{b.vehicle}</Cell>
      <Cell label="Date">{formatDMY(b.booking_date)}</Cell>
      <Cell label="Time">{b.start_time} – {b.return_time}</Cell>
      <Cell label="Actual return">{fmtTime(b.actual_return_datetime)}</Cell>
      <Cell label="Usage">{fmtDuration(b.actual_duration_minutes)}</Cell>
      <Cell label="Overdue"><span className={b.overdue_minutes > 0 ? "font-semibold text-red-600" : ""}>{fmtDuration(b.overdue_minutes)}</span></Cell>
      <Cell label="Battery">{b.current_battery_percentage != null ? `${b.current_battery_percentage}%` : "—"}</Cell>
    </div>
    <div className="mt-3 [&_button]:min-h-[44px] [&_button]:flex-1 [&_button]:justify-center [&>div]:flex-wrap">{actions}</div>
  </div>
);
